import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const UniqueScans = ({ totalScans = [], locations = {} }) => {
    const uniqueAddresses = new Set();

    totalScans.forEach(scan => {
        const key = `${scan.latitude},${scan.longitude}`;
        const address = scan.latitude && scan.longitude ? locations[key] : null;

        if (!address || address === "Unknown Location") {
            uniqueAddresses.add(`unknown-${Math.random()}`); // ensure uniqueness for nulls
        } else {
            uniqueAddresses.add(address);
        }
    });

    const uniqueCount = uniqueAddresses.size;

    return (
        <Card sx={{ backgroundColor: "#202020", padding: "1.5rem", borderRadius: "12px" }}>
            <CardContent>
                <Typography variant="h5" sx={{ color: "#12c099" }}>Unique Scans</Typography>
                <Typography variant="h4" sx={{ color: "#fff" }}>{uniqueCount}</Typography>
            </CardContent>
        </Card>
    );
};

export default UniqueScans;
